module.exports = __webpack_public_path__ + "static/media/chulalearnhub3.4f7a5cad.png";